<button type="button" class="btn btn-{{class}}" [class.active]="showFilter"
  placement="bottom-right" container="body" [ngbTooltip]="'ui.filter-tooltip'|translate"
  (click)="toggleFilter($event)"><i class="fa fa-filter"></i></button>
